<template>
    <div
        class="breadcrumbs"
        :class="`${blok.hideOn ? `hidden-${blok.hideOn}` : ''}`"
        :style="{ backgroundColor: blok.sectionBackground.color }"
    >
        <div class="container mx-auto breadcrumbs-container" :class="blok.align">
            <nuxt-link class="breadcrumbs-item parent-link home-link" :class="homeLinkClasses" to="/" external>
                <NuxtIcon name="ri:home-9-line" class="icon" />
                <span class="home-item-text">{{ $t('home') }}</span>
            </nuxt-link>

            <template v-for="(page, index) in blok.breadcrumbs" :key="page._uid">
                <NuxtIcon name="ri:arrow-right-s-line" class="breadcrumbs-divider" />
                <nuxt-link
                    v-if="index !== blok.breadcrumbs.length - 1"
                    :to="getInternalLink(page.Link)"
                    class="breadcrumbs-item parent-link"
                    external
                >
                    {{ page.Text }}
                </nuxt-link>

                <span v-else class="breadcrumbs-item current-page">{{ page.Text }}</span>
            </template>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { IBreadcrumbsConfig } from '~ui/types';
import { EHomeIconDisplayType } from '~ui/types/components/Breadcrumbs';
import { getInternalLink } from '~ui/utils/internalLinking';

const { blok } = defineProps<{ blok: IBreadcrumbsConfig }>();

const homeLinkClasses = computed(() => {
    return {
        icon: Number(blok.homeIconDisplay) === EHomeIconDisplayType.Always,
        'icon-mobile': Number(blok.homeIconDisplay) === EHomeIconDisplayType.OnlyMobile,
        'icon-desktop': Number(blok.homeIconDisplay) === EHomeIconDisplayType.OnlyDesktop,
        text: Number(blok.homeIconDisplay) === EHomeIconDisplayType.Never,
    };
});
</script>

<style lang="postcss" scoped>
.breadcrumbs {
    .container {
        &.center-content {
            @apply flex justify-center items-center;
        }
        &.right-content {
            @apply flex justify-end items-center;
        }
    }
    &.hidden-desktop {
        @apply md:hidden;
    }
    &.hidden-mobile {
        @apply max-md:hidden;
    }
    .breadcrumbs-container {
        @apply flex items-center;
    }
    .breadcrumbs-divider {
        @apply mx-1 md:mx-2 text-xs;

        &.iconify {
            @apply h-6 inline-block mr-2;
        }
    }

    .home-link {
        @apply flex items-center;

        .iconify {
            @apply h-4;
        }

        &.icon {
            .home-item-text {
                @apply hidden;
            }
        }
        &.icon-mobile {
            .iconify {
                @apply md:hidden;
            }
            .home-item-text {
                @apply hidden md:inline;
            }
        }
        &.icon-desktop {
            .iconify {
                @apply hidden md:inline;
            }
            .home-item-text {
                @apply md:hidden;
            }
        }
        &.text {
            .iconify {
                @apply hidden;
            }
        }
    }
}
</style>
